'use strict';

require('./src/assets/scss/init.scss');
require('gatsby-remark-vscode/styles.css');
